// API
import { tmxApiCall } from './index'

export default {
  async updateFieldTracking (applicationId, firstName, middleName, lastName, cellPhoneNumber, email, dateOfBirth, address, addressMailing, zip, mailingZip, idNumber, idExpiration, tin, incomeName, routingNum, accountNum) {
    return tmxApiCall('put', '/fieldTracking', {
      applicationId,
      firstName,
      middleName,
      lastName,
      cellPhoneNumber,
      email,
      dateOfBirth,
      address,
      addressMailing,
      zip,
      mailingZip,
      idNumber,
      idExpiration,
      tin,
      incomeName,
      routingNum,
      accountNum
    })
  }
}
